import { useState } from "react";

import HidePassword from "./HidePassword";
import { useTheme } from "@/utils/theme-context";
import ShowPassword from "./ShowPassword";

export const PasswordInput = ({ value, onChange, placeholder }) => {
  const [showPassword, setShowPassword] = useState(false);

  const { theme } = useTheme();

  return (
    <div className="password">
      <input
        className={`password__input input  input--${theme} `}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder || "Пароль"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      ></input>
      <button
        className="password__button"
        type="button"
        onClick={() => setShowPassword((prev) => !prev)}
      >
        {showPassword ? (
          <HidePassword theme={`#fff`}></HidePassword>
        ) : (
          <ShowPassword theme={"#fff"}></ShowPassword>
        )}
      </button>
    </div>
  );
};
